import { gql } from '@apollo/client';

export const REMOVE_PROPERTY_FROM_INCIDENT = gql`
mutation removePropertyFromIncident($input: RemovePropertyFromIncidentInput!) {
  removePropertyFromIncident(input: $input) {
    __typename
    clientMutationId
    errors
    propertyUuid
  }
}
`
